export * from '@ansyn/core/models/case.model';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/models/case.model.ts